// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-entity-table .ant-table .ant-table-selection-column {
  width: 0;
  padding: 0;
}
.general-entity-table .ant-table .ant-table-row {
  cursor: pointer;
}
.general-entity-table .ant-table .ant-table-row:hover {
  color: #137CBD;
}
.general-entity-table .ant-table .ant-table-row .ant-table-cell:has(.layer-preview-button) {
  text-align: center;
}
.general-entity-table .ant-table .ant-table-row .layer-preview-button {
  font-size: 1.5em;
}
.general-entity-table .ant-table .operation-column {
  font-size: 1.5em;
  text-align: center;
  color: #137CBD;
}
.general-entity-table .ant-table .operation-column .actions {
  display: flex;
  justify-content: space-around;
}
.general-entity-table .ant-table .operation-column .actions .anticon {
  cursor: pointer;
}
.general-entity-table .ant-table .operation-column .actions .anticon.anticon-delete {
  color: #ea2f5a;
}
`, "",{"version":3,"sources":["webpack://./src/Component/GeneralEntity/GeneralEntityTable/GeneralEntityTable.less"],"names":[],"mappings":"AAAA;EAIM,QAAA;EACA,UAAA;AAFN;AAHA;EASM,eAAA;AAHN;AAKM;EACE,cAAA;AAHR;AATA;EAgBQ,kBAAA;AAJR;AAZA;EAoBQ,gBAAA;AALR;AAfA;EAyBM,gBAAA;EACA,kBAAA;EACA,cAAA;AAPN;AApBA;EA8BQ,aAAA;EACA,6BAAA;AAPR;AAxBA;EAkCU,eAAA;AAPV;AASU;EACE,cAAA;AAPZ","sourcesContent":[".general-entity-table {\n\n  .ant-table {\n    .ant-table-selection-column {\n      width: 0;\n      padding: 0;\n    }\n\n    .ant-table-row {\n      cursor: pointer;\n\n      &:hover {\n        color: @primary-color;\n      }\n\n      .ant-table-cell:has(.layer-preview-button) {\n        text-align: center;\n      }\n\n      .layer-preview-button {\n        font-size: 1.5em;\n      }\n    }\n\n    .operation-column {\n      font-size: 1.5em;\n      text-align: center;\n      color: @primary-color;\n\n      .actions {\n        display: flex;\n        justify-content: space-around;\n\n        .anticon {\n          cursor: pointer;\n\n          &.anticon-delete {\n            color: #ea2f5a;\n          }\n        }\n      }\n    }\n  }\n\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
